module.exports = __webpack_public_path__ + "static/media/Edberghof03.84c1fc80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Edberghof03.jpg
// module id = 363
// module chunks = 0